/**
 * A guide's actions (Ask Elara, Shortlist, Add to trip…) follow the reader into the guide panel's floating
 * header once its own header has scrolled away, as the guide's title does. The panel provides the header's
 * slot ({@link GuideHeaderActionsSlot}); `GuideLayout` renders the same actions there inside
 * {@link CompactGuideActionsContext}, and each action button draws its icon-only form while it is set. One
 * node per guide, so the two copies cannot drift apart.
 */
import { createContext, useContext } from 'react';

/** Set while a guide's actions are drawn in the panel's floating header: each draws its icon-only form. */
export const CompactGuideActionsContext = createContext(false);

/** Whether this action is drawn in the panel's floating header, where it takes its icon-only form. */
export function useCompactGuideActions(): boolean {
  return useContext(CompactGuideActionsContext);
}

/** The floating header's slot for the guide's actions, provided by the guide panel; `null` outside it. */
export const GuideHeaderActionsSlot = createContext<HTMLElement | null>(null);
